module.exports = __webpack_public_path__ + "img/trash.6169da0a.svg";